import { Tag } from "antd";
import { formatTimeByTimezone, getLocalStorage, isEmpty } from "../../../utils/helpers";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
export const tagClass = "cursor-pointer border-none shadow-sm font-medium capitalize !rounded-md !px-2 !py-0.5";

export const emptyElement = (
    <div className="cursor-no-drop">
        <span className="text-xs">-</span>
    </div>
);

export const AccountTypeRender = ({ rowValue, keyValue }) => {
    let roleVal = rowValue[keyValue]?.split(" ").join("").toLowerCase();
    let customClass = "";
    if (isEmpty(roleVal)) return emptyElement;
    if (roleVal === "serviceaccount") {
        customClass = "bg-purple-100 text-purple-800";
        roleVal = "Service account"
    }
    if (roleVal === "user")
        customClass = "bg-primary/10 text-primary";
    return (
        <Tag className={` ${tagClass + " " + customClass}`}>{roleVal}</Tag>
    );
}

export const StatusRender = ({ rowValue, keyValue }) => {
    const statusVal = rowValue[keyValue]?.split(" ").join("").toLowerCase();
    let customClass = "";
    if (isEmpty(statusVal)) return emptyElement;
    if (statusVal === "active" || statusVal === "registered" || statusVal === "approved")
        customClass = "bg-green-100 text-green-800";
    if (statusVal === "inactive" || statusVal === "revoked")
        customClass = "bg-red-100 text-red-800";
    if (statusVal === "pending")
        customClass = "bg-orange-100 text-orange-800";
    return (
        <Tag className={` ${tagClass + " " + customClass}`}>{statusVal}</Tag>
    );
}


export const LinkRender = ({ rowValue, keyValue, isBlank = false }) => {
    const statusVal = rowValue[keyValue]?.split(" ").join("").toLowerCase();
    if (isEmpty(statusVal)) return emptyElement;
    return (
        <Link className="text-[13px] tracking-[0.2px]" target={isBlank ? "_blank" : "_self"} to={`https://${statusVal}`} >{statusVal}</Link>
    );
}

export const CustomRender = ({ renderValue }) => {
    if (renderValue === "-") return emptyElement;
    return (
        <span className="text-[13px] tracking-[0.2px]" >{renderValue}</span>
    );
}

export const TimezoneRender = ({ rowValue, keyValue }) => {
    const timeZone = getLocalStorage("timezone");
    if (isEmpty(timeZone)) return emptyElement;
    const formatDate = moment(rowValue[keyValue]).tz(timeZone).format("MM-DD-YYYY");
    return (
        <span className="text-[13px] tracking-[0.2px]" >{formatDate}</span>
    );
}


export const UserTimezoneRender = ({ rowValue, keyValue }) => {
    const timeZone = getLocalStorage("timezone");
    if (isEmpty(timeZone)) return emptyElement;
    const formatDate = formatTimeByTimezone(rowValue[keyValue], timeZone);
    return (
        <span className="text-[13px] tracking-[0.2px]" >{formatDate}</span>
    );
}

